export default "__VITE_ASSET__CiU4LoPV__"